import React, { useState } from "react";
import "./index.scss";
import { Box, Button, Typography } from "@mui/material";
import FormGenerator from "../../core/form-generator";
import { handleFormValidation } from "../../utils";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { USER_ROLES } from "../../utils/constants";

const ForgotPassword = () => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { type } = useParams();
  const formConfig = [
    {
      name: "email",
      type: "email",
      label: "Email",
      placeholder: "Enter your email",
      required: true,
      autoComplete: "off",
      validate: (value) =>
        !/\S+@\S+\.\S+/.test(value) ? "Email is invalid" : null,
    },
  ];
  const forgotPasswordHandler = () => {
    const isValid = handleFormValidation(formConfig, setErrors, formData);
    if (isValid) {
      let url = REST_URLS.FORGOT_PASSWORD;
      if (type === USER_ROLES.OEM) {
        url = REST_URLS.OEM_FORGOT_PASSWORD;
      }
      invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${url}`, formData)
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.success("We have sent you an email to reset your password.");
            setFormData({});
          }
        })
        .catch((err) => console.error(err));
    }
  };
  return (
    <div className="forgot-pass-con">
      <div className="content-con">
        <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center" }}>
          Forgot Password?
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "gray", textAlign: "center", mt: 1 }}
        >
          No worries, we'll send you reset instruction.
        </Typography>
        <Box
          sx={{
            width: { md: "70%", xs: "100%", sm: "100%" },
          }}
        >
          <FormGenerator
            config={formConfig}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            fieldGridSize={12}
          />
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            onClick={forgotPasswordHandler}
          >
            Reset Password
          </Button>
          <Button fullWidth sx={{ mt: 2 }} onClick={() => navigate("/")}>
            Back to Login
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default ForgotPassword;
